const KEY = 'drapp-ui-preference'

// `?ui=legacy` / `?ui=next` en la URL gana sobre el flag mientras dure la
// sesión de la tab — anti-loop entre drmanager y web (UI_REFACTOR_PLAN.md
// §7: tras un opt-out en web, drmanager podría leer un `/features` cacheado
// viejo con web_ui:true y rebotar al usuario de nuevo) y herramienta de
// soporte/QA para forzar una UI sin tocar el flag real del team/usuario.
export function captureUiPreference(search) {
  const ui = new URLSearchParams(search).get('ui')
  if (ui !== 'legacy' && ui !== 'next') return
  try {
    window.sessionStorage.setItem(KEY, ui)
  } catch {}
}

export function readUiPreference() {
  try {
    return window.sessionStorage.getItem(KEY)
  } catch {
    return null
  }
}

// Bug real (QA-Cormos, 2026-09-02): NewUiBanner/Navbar decidían texto/
// visibilidad/qué mandar al toggle mirando SOLO `features.webUi` (el flag
// real del servidor), ignorando el override de sesión — un usuario que
// vuelve de `web` con `?ui=legacy` sigue teniendo `webUi:true` real, pero
// está VIENDO drmanager por el override, no por el flag. Sin esto: (a) el
// banner desaparece (su gate es `!webUi`, y `webUi` real sigue en true) y
// (b) el botón del menú de cuenta muestra "Volver a la versión anterior"
// (lee `webUi:true`) y al clickear manda `setWebUi(!true)` = `enabled:false`
// — apaga el flag real en vez de llevar a la nueva UI, y como
// useWebUiToggle sólo redirige cuando `enabled` es true, tampoco navega a
// ningún lado. Toda decisión de UI-elegida-ahora debe usar esto, no
// `features.webUi` a secas.
export function effectiveWebUi(realWebUi) {
  return readUiPreference() === 'legacy' ? false : realWebUi
}
